import React from 'react';
import { Pane, Text } from '@ui';
import { translate } from '@utils/i18n';
import useTceTemplateDiagnostic from '@hooks/requests/tce-template-diagnostic.get.hook';
import TemplateDiagnosticForm from './TemplateDiagnosticForm';
import TemplateVerdictTable from './TemplateVerdictTable';
import './TceTemplateDiagnosticStyles.scss';
const NAMESPACE = 'features.settings.integrations.tce_template_diagnostic';
/**
 * Answers one question on the TCE integration page: why is this report
 * template not in the submission wizard?
 *
 * The verdicts come from the same call and the same filter the wizard uses, so
 * the answer cannot drift from what the wizard actually does.
 *
 * Mounts via react_component('Settings/Integrations/TceTemplateDiagnostic').
 */
function TceTemplateDiagnostic() {
    var _a;
    const { result, loading, error, run } = useTceTemplateDiagnostic();
    const onSubmit = (premiseId, inspectionId) => {
        void run(premiseId, inspectionId);
    };
    return (React.createElement("div", { className: "tce-template-diagnostic-section" },
        React.createElement(Pane, { title: translate('title', { namespace: NAMESPACE }), subtitle: translate('subtitle', { namespace: NAMESPACE }) },
            React.createElement("div", { className: "tce-template-diagnostic" },
                React.createElement(TemplateDiagnosticForm, { onSubmit: onSubmit, loading: loading }),
                error !== null && (React.createElement("div", { className: "tce-template-diagnostic__error" },
                    React.createElement("i", { className: "fa-light fa-triangle-exclamation", "aria-hidden": "true" }),
                    React.createElement(Text, { variant: "body", as: "p" }, error))),
                result !== null && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "tce-template-diagnostic__meta" },
                        React.createElement(Text, { variant: "x-small", as: "p" }, `${translate('tce_host', { namespace: NAMESPACE })}: ${(_a = result.tceHost) !== null && _a !== void 0 ? _a : '—'}`),
                        React.createElement(Text, { variant: "x-small", as: "p" }, `${translate('code_types', { namespace: NAMESPACE })}: ${result.codeTypes.join(', ')}`),
                        result.credentialContext !== null && (React.createElement(Text, { variant: "x-small", as: "p" }, result.credentialContext))),
                    React.createElement("div", { className: "tce-template-diagnostic__results" },
                        React.createElement(TemplateVerdictTable, { templates: result.templates }))))))));
}
export default TceTemplateDiagnostic;
